import type * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { Seller } from './Seller';

import { Divider } from '../Divider';
import * as style from './ShowPhonesModal.css';
import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';

export interface IShowPhonesModalProps {
  isOpen: boolean;
  newbuildingId: number;
  builders: INewbuildingBuilder[];
  sellers: ISeller[];
  leadFactorySeller?: ISeller;
  placeType: string;
  trackActionCall(builder: INewbuildingBuilder): void;
  onModalClose(): void;
}

export function ShowPhonesModal({
  isOpen,
  builders,
  sellers,
  leadFactorySeller,
  trackActionCall,
  onModalClose,
  placeType,
}: IShowPhonesModalProps): React.JSX.Element {
  if (leadFactorySeller) {
    return (
      <ModalWindow
        open={isOpen}
        onClose={onModalClose}
        content={
          <div>
            <Seller
              siteBlockId={leadFactorySeller.dynamicCalltracking?.siteBlockId}
              builderOrSeller={leadFactorySeller}
              label="Консультант"
              trackAction={trackActionCall}
              placeType={placeType}
            />
          </div>
        }
      />
    );
  }

  return (
    <ModalWindow
      open={isOpen}
      onClose={onModalClose}
      content={
        <div>
          {!!builders.length &&
            builders.map(builder => {
              return (
                <Seller
                  siteBlockId={builder.dynamicCalltracking?.siteBlockId}
                  key={`${builder.id}`}
                  builderOrSeller={builder}
                  label="Застройщик"
                  trackAction={trackActionCall}
                  placeType={placeType}
                />
              );
            })}
          {!!builders.length && !!sellers.length && (
            <div className={style['divider']}>
              <Divider />
            </div>
          )}
          {!!sellers.length &&
            sellers.map(seller => {
              return (
                <Seller
                  siteBlockId={seller.dynamicCalltracking?.siteBlockId}
                  key={`${seller.realtyUserId}`}
                  builderOrSeller={seller}
                  label="Агентство недвижимости"
                  trackAction={trackActionCall}
                  placeType={placeType}
                />
              );
            })}
        </div>
      }
    />
  );
}
